import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dropdown-down",
  "use": "dropdown-down-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 7\" id=\"dropdown-down\"><path d=\"M5 6.5L.67.5h8.66L5 6.5z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol